import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

export default function NoOptionsMessage(props) {
	const { inputValue, minSearchLength } = props.selectProps;

	let message = props.children;

	// Custom message adding clarity when user requires min 3 character input before API is hit
	if (minSearchLength && inputValue && inputValue.length < minSearchLength) {
		message = `Type at least ${minSearchLength} characters`;
	}

	return (
		<Typography
			color="textSecondary"
			className={props.selectProps.classes.noOptionsMessage}
			{...props.innerProps}
		>
			{message}
		</Typography>
	);
}

NoOptionsMessage.propTypes = {
	innerProps: PropTypes.object,
	selectProps: PropTypes.object,
	children: PropTypes.node,
};
